import Cookies from "js-cookie";
import config from "./config";

const COOKIE_KEY = "loginSuccessKlcAdmin";
const LEGACY_STORAGE_KEY = "klcAdminLoggedIn";

export function getAdminSession() {
  try {
    const raw = Cookies.get(COOKIE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function getAdminAuthToken() {
  const session = getAdminSession();
  return session?.authToken || session?.token || session?.access_token || session?.accessToken || "";
}

/**
 * Logged in only when a real auth token exists.
 * Legacy localStorage flag alone must not grant access (causes dashboard + "Missing token").
 */
export function isAdminLoggedIn() {
  return Boolean(getAdminAuthToken());
}

export function setAdminSession(sessionObj) {
  Cookies.set(COOKIE_KEY, JSON.stringify(sessionObj || {}));
  try {
    window.localStorage.setItem(LEGACY_STORAGE_KEY, "true");
  } catch {
    // ignore
  }
}

export function adminLogout() {
  Cookies.remove(COOKIE_KEY);
  try {
    window.localStorage.removeItem(LEGACY_STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** Clear stale session and send user to admin login. */
export function redirectToAdminLogin() {
  adminLogout();
  const base = (config.baseUrl || "/").replace(/\/+$/, "") || "/";
  const loginPath = `${base}/login`.replace("//", "/");
  if (!window.location.pathname.includes("/login")) {
    window.location.assign(loginPath);
  }
}
